type IconProps = {
  color?: string
  className?: string
}

const BielefieldLogo: React.FC<IconProps> = ({ color = 'currentColor', ...attributes }) => {
  return (
    <svg width="35" height="49" viewBox="0 0 35 49" fill={color} xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="m34.3129 48.5894h-7.4085v-29.473h7.4085zm-11.4132-8.7602c0 5.1838-4.1381 8.7546-9.6055 8.7546h-13.2653914v-29.4674h10.2562914c5.4285 0 9.6 3.4818 9.6 8.7045.0445 1.8076-.5673 3.5652-1.7242 4.9557 2.9367 1.0846 4.8445 3.9268 4.7388 7.0526zm-15.76267-9.0605h2.86997c1.7632 0 2.8422-1.0289 2.8422-2.5919 0-1.5629-1.079-2.5863-2.8422-2.5863h-2.86997v5.1838zm8.33187 8.7546c0-1.7409-1.1235-2.5863-2.8477-2.5863h-5.48417v5.2004h5.48967c1.7242 0 2.8478-.8454 2.8478-2.5863m18.8384-38.961745h-7.4085v6.374045h-6.2072v-6.374045h-7.0526v6.374045h-6.20166v-6.374045h-7.4141314v13.715845h34.2840914z"
        fill="#fff"
      />
    </svg>
  )
}

export default BielefieldLogo
